<template>
  <Checkout
    v-bind="$attrs"
    :action="route('checkout.payment', order)"
    :back="route('checkout', { order, step: 'shipping' })"
    :order="order"
    :submit="submit"
    action-text="Bestellung überprüfen"
    back-text="Zurück zum Versand"
    step="payment"
    data-fb-track="AddPaymentInfo"
    :data-fb-data="JSON.stringify({ currency: 'EUR', value: order.cart.total_discounted })"
  >
    <template #default>
      <h1 class="text-lg text-blue-500 mb-2">Zahlung</h1>
      <div class="border border-gray-300 rounded-md divide-y divide-gray-300 text-gray-800">
        <label
          v-for="method in methods"
          class="flex items-center px-4 py-3.5 cursor-pointer leading-tight"
          :key="method.id"
        >
          <input
            v-model="form.payment_method"
            :value="method.id"
            class="form-radio flex-shrink-0 mr-4"
            name="payment_method"
            type="radio"
          >
          <span class="flex-1">{{ method.description }}</span>
          <img
            v-if="method.image"
            class="w-10 -my-1.5 -mr-1.5"
            height="24"
            width="32"
            :src="method.image.svg"
            :alt="method.description"
          >
        </label>
      </div>
      <div v-if="order.total" class="mt-12">
        <h2 class="text-lg text-blue-500 mb-1">Servicegebühr</h2>
        <p class="text-gray-700 text-sm leading-normal">
          Bei jeder Bestellung, bei der eine Transaktion anfällt, erheben wir eine pauschale Servicegebühr von {{ formatPrice(surcharge.price) }} u. a. für die Bearbeitung Ihres Auftrags und die Instandhaltung des DAS DA-Onlineshops.
          Von der Servicegebühr ausgenommen ist das Einlösen einer Abo-Nummer.
        </p>
      </div>
    </template>
  </Checkout>
</template>

<script>
import Checkout from 'Web/Layouts/Checkout.vue';
import { onMounted, reactive, toRefs } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import formatPrice from '@/helpers/formatPrice';

export default {
  inheritAttrs: false,
  components: {
    Checkout,
  },
  props: {
    methods: {
      type: Array,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    surcharge: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      form: null,
    });

    state.form = useForm('payment', {
      payment_method: null,
    });

    function method() {
      let method = props.order.payment_method;

      if (!props.methods.some(({ id }) => id === method))
        method = props.methods[0].id

      return method;
    }

    onMounted(() => {
      state.form.payment_method = method();
      state.form.clearErrors();
    });

    function submit(event) {
      state.form.post(event.target.action);
    }

    return {
      ...toRefs(state),
      formatPrice,
      submit,
    }
  }
}
</script>
